import React from "react";

export default function UnderDevelopmentState({
  title = "Module Under Development",
  message = "This section is currently being updated and will be available soon.",
  compact = false,
}) {
  return (
    <div className={`harwin-dev-state${compact ? " compact" : ""}`}>
      <div className="harwin-dev-icon">🚧</div>
      <div>
        <div className="harwin-dev-title">{title}</div>
        <div className="harwin-dev-message">{message}</div>
      </div>
      <style>{`
        .harwin-dev-state{display:flex;align-items:center;justify-content:center;gap:16px;min-height:180px;padding:28px;background:#fffbeb;border:1px solid #fde68a;border-radius:14px;text-align:left}
        .harwin-dev-state.compact{min-height:0;padding:16px 18px;justify-content:flex-start}
        .harwin-dev-icon{width:48px;height:48px;flex:0 0 48px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:#fef3c7;font-size:24px}
        .harwin-dev-title{font-size:17px;font-weight:800;color:#92400e;margin-bottom:4px}
        .harwin-dev-message{font-size:13px;line-height:1.55;color:#a16207}
      `}</style>
    </div>
  );
}
